import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'presto-modern-skin',
  styleUrl: 'presto-modern-skin.scss',
  shadow: false,
})
export class PrestoModernSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
